export {default} from './StaahListingDetailModel';
export {StaahListingDetailModelType} from './StaahListingDetailModel';



// WEBPACK FOOTER //
// ./src/models/StaahListingDetailModel/index.ts